import React from 'react';
import {ScrollView} from 'react-native';

import ContentView from '../../components/ui-controls/layout/ContentView';
import Markdown from '../../components/ui-controls/Markdown';
import config, {Brand} from '../../config';
import {AppRoute} from '../../models/AppRoute';
import {
  RootStoreSelectionNavigatorScreenProps,
  RouteNavigatorScreenProps,
} from '../../models/navigationTypes';
import {interpolateMarkdownTemplate} from '../../utils/interpolateMarkdownTemplate';
import {openPageLink} from '../../utils/navigation';

import giftCardsTermsAndConditionsMarkdown from './content/giftCardsTermsAndConditions.md';
import giftCardsTermsAndConditionsThirstyCamelMarkdown from './content/giftCardsTermsAndConditions.thirstycamel.md';

// Don't format on save!
// This will live in Airtable:
//  1862-Content configuration in Airtable (T&Cs, etc.)
//  https://dev.azure.com/lmgdevops/branded_website/_workitems/edit/1862

// Brand-specific T&C copy. Brands not listed here fall back to the default copy.
const termsAndConditionsByTenant: Partial<Record<Brand, string>> = {
  [Brand.THIRSTY_CAMEL]: giftCardsTermsAndConditionsThirstyCamelMarkdown,
};

const copy = interpolateMarkdownTemplate(
  termsAndConditionsByTenant[config.BASE_TENANT] ?? giftCardsTermsAndConditionsMarkdown,
  {
    APP_NAME: config.APP_NAME,
    SUPPORT_EMAIL: config.SUPPORT_EMAIL,
  },
);

const GiftCardsTermsAndConditionsScreen = (
  _:
    | RouteNavigatorScreenProps<AppRoute.GIFT_CARDS_TERMS_AND_CONDITIONS>
    | RootStoreSelectionNavigatorScreenProps<AppRoute.ROOT_GIFT_CARDS_TERMS_AND_CONDITIONS>,
) => (
  <ContentView testID="gift-cards-terms-and-conditions-screen">
    <ScrollView>
      {/* Own-domain links (participating stores, promotions, balance) stay in-app
          via openPageLink; returning false suppresses the markdown lib's default
          Linking.openURL so the user is not bounced to the browser. DIS-1514. */}
      <Markdown
        onLinkPress={url => {
          openPageLink(url);
          return false;
        }}>
        {copy}
      </Markdown>
    </ScrollView>
  </ContentView>
);

export default GiftCardsTermsAndConditionsScreen;
